var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForecastingCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 185,
    viewBox: "0 0 246 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5438_171301)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 185,
    fill: "url(#paint0_linear_5438_171301)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter0_ddd_5438_171301)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: -0.5,
    r: 210.5,
    fill: "#FFF2E9"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter1_ddd_5438_171301)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 134,
    fill: "#FFF2E9"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter2_ddd_5438_171301)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 74,
    fill: "#FFF2E9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.971 160.611C171.971 161.953 171.726 162.925 171.242 163.501C170.951 163.799 170.596 164.029 170.204 164.173C169.811 164.318 169.391 164.373 168.974 164.336C168.553 164.377 168.128 164.321 167.734 164.171C167.339 164.021 166.986 163.782 166.702 163.473C166.161 162.618 165.911 161.615 165.989 160.61V147.691H160.055V160.907C160.055 163.521 160.843 165.545 162.397 166.922C163.938 168.287 166.15 168.979 168.974 168.979C171.882 168.979 174.12 168.274 175.625 166.882C177.13 165.49 177.907 163.468 177.907 160.893V147.691H171.971V160.611ZM172.801 148.51H177.077V160.896C177.077 163.236 176.398 165.049 175.058 166.287C173.719 167.524 171.666 168.163 168.974 168.163C166.362 168.163 164.336 167.54 162.952 166.315C161.58 165.1 160.885 163.281 160.885 160.91V148.51H165.16V160.611C165.078 161.796 165.388 162.976 166.044 163.972C166.402 164.384 166.855 164.705 167.364 164.911C167.873 165.116 168.424 165.2 168.972 165.155C169.512 165.196 170.054 165.115 170.557 164.919C171.061 164.723 171.512 164.417 171.878 164.024C172.489 163.297 172.799 162.148 172.799 160.611L172.801 148.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.619 169H211.192V164.261H202.527V159.913H210.512V155.175H202.527V152.41H211.193V147.671H196.62L196.619 169ZM197.448 148.501H210.364V151.582H201.697V156.001H209.682V159.082H201.697V165.087H210.364V168.168H197.448V148.501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.518 164.886H219.206C220.565 164.886 221.472 164.877 221.978 164.859C222.566 164.832 223.144 164.697 223.682 164.462C224.195 164.259 224.624 163.89 224.897 163.415C225.149 162.956 225.277 162.44 225.27 161.918C225.3 161.32 225.139 160.728 224.81 160.225C224.472 159.784 224.005 159.456 223.472 159.286C223.017 159.135 222.54 159.06 222.06 159.064C221.513 159.051 220.777 159.044 219.873 159.044H218.516L218.518 164.886ZM219.348 159.863H219.875C220.769 159.863 221.498 159.87 222.042 159.883C222.431 159.878 222.818 159.936 223.188 160.054C223.565 160.169 223.896 160.395 224.139 160.701C224.364 161.066 224.471 161.491 224.443 161.918C224.45 162.302 224.358 162.681 224.174 163.02C223.989 163.336 223.7 163.579 223.354 163.71C222.91 163.905 222.433 164.017 221.947 164.041C221.467 164.057 220.616 164.066 219.346 164.067L219.348 159.863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.754 158.701C229.112 158.014 228.306 157.496 227.408 157.195C227.984 156.819 228.471 156.326 228.836 155.748C229.38 154.881 229.661 153.879 229.645 152.86C229.661 151.998 229.458 151.146 229.056 150.381C228.642 149.639 228.017 149.033 227.258 148.638C226.544 148.25 225.765 147.99 224.958 147.871C223.812 147.734 222.658 147.675 221.504 147.695H213.91V163.645C213.656 163.734 213.441 163.908 213.303 164.136C213.165 164.365 213.113 164.634 213.155 164.897C213.197 165.16 213.332 165.4 213.534 165.575C213.737 165.751 213.996 165.851 214.265 165.858C214.535 165.865 214.799 165.779 215.011 165.614C215.223 165.45 215.369 165.217 215.426 164.957C215.482 164.696 215.444 164.425 215.319 164.189C215.194 163.954 214.989 163.769 214.74 163.666V148.52H221.504C222.617 148.5 223.73 148.556 224.836 148.687C225.546 148.792 226.233 149.021 226.862 149.363C227.48 149.682 227.99 150.174 228.328 150.777C228.663 151.42 228.831 152.136 228.816 152.86C228.83 153.722 228.595 154.57 228.136 155.304C227.694 156.001 227.042 156.545 226.272 156.86L226.019 156.966V157.688L226.348 157.757C227.419 157.952 228.399 158.478 229.146 159.26C229.864 160.108 230.23 161.194 230.169 162.298C230.188 163.159 230.007 164.013 229.639 164.794C229.304 165.482 228.816 166.087 228.211 166.563C227.51 167.122 226.703 167.536 225.837 167.781C224.734 168.052 223.599 168.177 222.462 168.15H214.379V168.982H222.46C223.672 169.009 224.881 168.874 226.056 168.582C227.028 168.308 227.933 167.844 228.719 167.218C229.422 166.665 229.988 165.963 230.378 165.164C230.802 164.269 231.013 163.289 230.994 162.301C231.059 160.989 230.616 159.702 229.754 158.701V158.701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.632 168.151H180.893V148.52H185.169V165.076H188.67C188.768 165.257 188.914 165.408 189.092 165.513C189.27 165.618 189.474 165.674 189.682 165.674C189.89 165.674 190.094 165.618 190.272 165.513C190.451 165.408 190.597 165.257 190.695 165.076L190.772 164.893C190.812 164.779 190.834 164.66 190.835 164.539C190.835 164.263 190.734 163.997 190.55 163.79C190.366 163.583 190.112 163.449 189.835 163.413C189.558 163.378 189.278 163.443 189.046 163.597C188.814 163.75 188.647 163.982 188.576 164.248H186V147.692H180.065V168.982H194.462V164.251H193.633L193.632 168.151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.662 148.512C155.75 148.765 155.924 148.978 156.155 149.117C156.386 149.255 156.658 149.31 156.926 149.271C157.193 149.232 157.438 149.102 157.618 148.903C157.798 148.705 157.902 148.45 157.912 148.184C157.922 147.918 157.838 147.656 157.673 147.445C157.508 147.234 157.274 147.086 157.01 147.028C156.746 146.969 156.47 147.004 156.23 147.125C155.989 147.246 155.799 147.447 155.693 147.691H147.308V152.167H151.962V159.836C151.962 160.533 151.951 161.181 151.929 161.761C151.919 162.24 151.811 162.712 151.614 163.149C151.444 163.524 151.145 163.827 150.771 164.006C150.176 164.26 149.529 164.373 148.882 164.338C148.344 164.353 147.806 164.289 147.288 164.148C146.854 164.012 146.431 163.863 146.033 163.705L145 163.671V168.506L145.329 168.575C146.035 168.718 146.749 168.818 147.467 168.874C148.267 168.943 149.134 168.977 150.042 168.977C151.169 168.993 152.293 168.841 153.374 168.525C154.326 168.236 155.203 167.745 155.943 167.085C156.599 166.502 157.105 165.773 157.418 164.959C157.739 164.122 157.901 163.235 157.896 162.34V152.092H157.066V162.342C157.072 163.135 156.928 163.923 156.644 164.665C156.377 165.359 155.946 165.981 155.387 166.479C154.736 167.058 153.964 167.49 153.125 167.744C152.125 168.035 151.085 168.175 150.042 168.158C149.152 168.158 148.311 168.125 147.539 168.059C146.913 168.005 146.34 167.934 145.83 167.839V164.51C146.216 164.661 146.622 164.803 147.036 164.933C147.636 165.1 148.259 165.178 148.882 165.162C149.662 165.201 150.441 165.055 151.153 164.736C151.692 164.473 152.121 164.033 152.367 163.492C152.609 162.958 152.741 162.381 152.754 161.797C152.777 161.211 152.788 160.552 152.788 159.839V151.346H148.137V148.512H155.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.703 156.395C223.142 156.167 223.489 155.798 223.687 155.349C223.893 154.876 223.996 154.366 223.988 153.852C224.016 153.265 223.887 152.681 223.616 152.158C223.367 151.739 222.987 151.41 222.533 151.22C222.171 151.071 221.782 150.996 221.389 150.998C220.948 150.985 220.349 150.979 219.618 150.979H218.519V156.82H219.076C220.177 156.82 220.911 156.811 221.322 156.793C221.806 156.764 222.278 156.628 222.703 156.395V156.395ZM219.191 156.001V151.797H219.618C220.342 151.797 220.932 151.804 221.373 151.817C221.691 151.813 222.006 151.871 222.301 151.988C222.621 152.117 222.891 152.344 223.07 152.635C223.256 153.013 223.341 153.432 223.317 153.852C223.324 154.23 223.25 154.605 223.099 154.953C222.966 155.252 222.732 155.496 222.437 155.644C222.087 155.836 221.697 155.949 221.297 155.974C220.908 155.991 220.219 156 219.189 156.001H219.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9596 85.7874C25.9846 85.7874 24.1346 85.1874 22.6096 83.7374C21.3846 82.5874 20.9346 80.5874 20.9346 78.5624V70.3874H24.4346V78.1374C24.4346 79.6124 24.7096 80.6874 25.4846 81.3374C26.3346 82.0624 27.7346 82.2874 29.2096 82.2874H31.2096V70.3874H34.7096V85.7874H28.9596ZM27.9346 68.1624C26.8346 68.1624 25.8846 67.5124 25.8846 66.2874C25.8846 65.1874 26.7846 64.4374 27.9346 64.4374C29.1096 64.4374 29.9846 65.1874 29.9846 66.2874C29.9846 67.5124 29.0346 68.1624 27.9346 68.1624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1344 68.5874L50.1094 81.7124C50.1094 85.5124 48.6094 88.1624 43.6844 88.1624C42.3344 88.1624 41.5594 87.9874 40.0344 87.5624L39.7844 84.0374C41.1344 84.4624 42.2594 84.6624 43.4344 84.6624C45.3594 84.6624 46.3594 84.4124 46.5844 82.6624H46.1844C41.4094 82.6624 37.6094 80.6374 37.6094 75.6124C37.6094 71.2374 41.1844 68.5874 46.1844 68.5874H50.1344ZM41.1094 75.6124C41.1094 77.9374 42.9094 79.1624 45.1594 79.1624H46.6344V72.0874H45.1594C43.0844 72.0874 41.1094 73.4874 41.1094 75.6124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4146 88.1624C53.7646 88.1624 53.0646 88.0624 52.6396 87.9374L52.3896 84.4374C53.0396 84.6124 53.5146 84.6624 54.0396 84.6624C55.4397 84.6624 55.9146 83.9374 55.9146 82.2124V68.5874H59.4146V79.1624H62.1147V82.6624H59.3896C59.1896 86.5124 57.7147 88.1624 54.4146 88.1624ZM57.5896 66.4624C56.4896 66.4624 55.5396 65.8124 55.5396 64.5874C55.5396 63.4874 56.4396 62.7374 57.5896 62.7374C58.7646 62.7374 59.6396 63.4874 59.6396 64.5874C59.6396 65.8124 58.6896 66.4624 57.5896 66.4624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.625 82.6624V79.1624H71C71.25 78.0624 71.425 76.6374 71.425 75.5874C71.425 74.5624 71.075 73.3374 70.2 72.5624C69.5 71.9374 68.5 71.6124 67.25 71.6124C65.925 71.6124 64.925 71.8874 63.625 72.7124L62.175 69.6624C63.8 68.7374 65.575 68.1124 67.675 68.1124C69.725 68.1124 71.45 68.8124 72.65 70.0374C73.975 71.3624 74.9 73.3374 74.9 75.8624C74.9 76.9874 74.775 78.1124 74.575 79.1624H77.275V82.6624H60.625ZM67.225 66.0124C66.125 66.0124 65.175 65.3624 65.175 64.1374C65.175 63.0374 66.075 62.2874 67.225 62.2874C68.4 62.2874 69.275 63.0374 69.275 64.1374C69.275 65.3624 68.325 66.0124 67.225 66.0124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8105 82.6624V79.1624H79.2355C79.1105 78.6624 79.0605 78.1124 79.0605 77.5624C79.0605 73.3124 82.4105 69.9124 86.5355 69.9124C90.7605 69.9124 94.1355 73.2374 94.1355 77.5624C94.1355 78.1124 94.0605 78.6624 93.9605 79.1624H96.7606V82.6624H92.0855C90.6855 84.1374 88.6855 85.0374 86.5355 85.0374C84.4105 85.0374 82.4605 84.1124 81.0855 82.6624H76.8105ZM86.5355 81.5374C88.8355 81.5374 90.6355 79.8624 90.6355 77.5124C90.6355 75.1624 88.9355 73.4124 86.5355 73.4124C84.2105 73.4124 82.5605 75.2374 82.5605 77.5124C82.5605 79.7624 84.2855 81.5374 86.5355 81.5374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2686 82.6624V79.1624H98.7186V62.3874H102.219V82.6624H96.2686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.355 82.6624V62.3874H110.855V79.1624H114.055V82.6624H107.355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.454 87.9874C117.354 87.9874 116.404 87.3374 116.404 86.1124C116.404 85.0124 117.304 84.2624 118.454 84.2624C119.629 84.2624 120.504 85.0124 120.504 86.1124C120.504 87.3374 119.554 87.9874 118.454 87.9874ZM113.554 82.6624V79.1624H116.654V68.5874H120.154V82.6624H113.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.054 68.5874L143.029 79.1624H145.354V82.6624H142.979C142.729 85.9374 141.104 88.1624 136.604 88.1624C135.254 88.1624 134.479 87.9874 132.954 87.5624L132.704 84.0374C134.054 84.4624 135.179 84.6624 136.354 84.6624C138.279 84.6624 139.279 84.4124 139.504 82.6624H139.104C134.329 82.6624 130.529 80.6374 130.529 75.6124C130.529 71.2374 134.104 68.5874 139.104 68.5874H143.054ZM134.029 75.6124C134.029 77.9374 135.829 79.1624 138.079 79.1624H139.554V72.0874H138.079C136.004 72.0874 134.029 73.4874 134.029 75.6124ZM137.779 66.6374V64.8124C137.779 62.5624 138.979 61.7124 140.929 61.7124H142.429V62.8374H141.129C140.129 62.8374 139.779 63.2874 139.779 64.0874V64.7624H143.229V66.6374H137.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.877 82.6624V79.1624H147.977V68.5874H151.477V79.1624H154.152V82.6624H144.877ZM149.727 87.9874C148.627 87.9874 147.677 87.3374 147.677 86.1124C147.677 85.0124 148.577 84.2624 149.727 84.2624C150.902 84.2624 151.777 85.0124 151.777 86.1124C151.777 87.3374 150.827 87.9874 149.727 87.9874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.666 82.6624V79.1624H156.766V68.5874H160.266V79.1624H162.941V82.6624H153.666ZM158.416 66.4624C157.316 66.4624 156.366 65.8124 156.366 64.5874C156.366 63.4874 157.266 62.7374 158.416 62.7374C159.591 62.7374 160.466 63.4874 160.466 64.5874C160.466 65.8124 159.516 66.4624 158.416 66.4624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.455 82.6624V79.1624H167.68V68.5874H171.18V79.1624H175.78V82.6624H162.455ZM171.98 66.4624C170.93 66.4624 170.03 65.8374 170.03 64.6624C170.03 63.6124 170.88 62.8874 171.98 62.8874C173.105 62.8874 173.93 63.6124 173.93 64.6624C173.93 65.8374 173.03 66.4624 171.98 66.4624ZM166.555 66.4624C165.505 66.4624 164.605 65.8374 164.605 64.6624C164.605 63.6124 165.455 62.8874 166.555 62.8874C167.655 62.8874 168.505 63.6124 168.505 64.6624C168.505 65.8374 167.605 66.4624 166.555 66.4624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.272 82.6624V79.1624H177.722V62.3874H181.222V82.6624H175.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.359 82.6624V62.3874H189.859V82.6624H186.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6596 117.662H22.0596V97.3874H34.9846V100.737H25.6596V105.562H34.0846V108.962H25.6596V117.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7078 117.962C39.3828 117.962 36.0828 114.737 36.0828 110.537C36.0828 106.362 39.3828 103.087 43.7078 103.087C48.0328 103.087 51.3328 106.362 51.3328 110.537C51.3328 114.737 48.0328 117.962 43.7078 117.962ZM43.7078 114.537C46.1578 114.537 47.6578 112.762 47.6578 110.537C47.6578 108.337 46.1578 106.512 43.7078 106.512C41.2578 106.512 39.7578 108.337 39.7578 110.537C39.7578 112.762 41.2578 114.537 43.7078 114.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3523 103.362V106.712H60.3523C59.8023 106.712 58.1023 106.812 57.6773 106.962V117.662H54.1773V103.962C55.9273 103.612 58.2523 103.362 59.7023 103.362H62.3523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7643 114.537H72.1393C73.6143 114.537 75.5143 113.987 76.2643 113.287L77.8143 116.412C76.3143 117.237 74.4393 117.962 71.6643 117.962C67.2143 117.962 63.9393 114.762 63.9393 110.537C63.9393 106.187 67.2643 103.087 71.4143 103.087C75.7393 103.087 78.8643 106.262 78.6893 111.687H67.5393C67.9893 113.612 69.5893 114.537 71.7643 114.537ZM71.3643 106.187C69.4893 106.187 68.0893 107.287 67.6643 108.787H75.0143C74.6393 107.062 73.2643 106.187 71.3643 106.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7117 110.537C80.7117 106.287 83.9117 103.087 88.2617 103.087C90.1867 103.087 91.7117 103.512 93.1367 104.237L91.7367 107.387C90.8117 106.862 89.7117 106.512 88.4117 106.512C85.9867 106.512 84.3867 108.137 84.3867 110.537C84.3867 112.937 85.9867 114.537 88.4117 114.537C89.7117 114.537 90.8117 114.212 91.7367 113.662L93.1367 116.837C91.7117 117.562 90.1867 117.962 88.2617 117.962C83.9117 117.962 80.7117 114.812 80.7117 110.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.621 114.412V111.562C103.971 111.387 103.021 111.262 102.246 111.262C100.471 111.262 98.9713 111.712 98.9713 113.062C98.9713 114.362 100.321 114.812 102.046 114.812C102.921 114.812 103.871 114.662 104.621 114.412ZM101.996 117.962C98.4713 117.962 95.3213 116.737 95.3213 113.287C95.3213 110.137 98.0463 108.512 101.871 108.512C102.621 108.512 103.571 108.562 104.621 108.712V108.512C104.621 106.912 103.296 106.462 101.371 106.462C99.9213 106.462 97.7963 107.037 96.4213 107.712L96.8713 104.137C97.9963 103.587 99.8963 103.087 101.846 103.087C105.471 103.087 108.121 104.562 108.121 108.662V116.862C106.346 117.562 104.071 117.962 101.996 117.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.267 114.537C118.692 114.537 119.892 114.237 119.892 113.437C119.892 112.712 119.367 112.362 117.567 112.012L116.442 111.812C113.267 111.212 111.342 109.862 111.342 107.437C111.342 104.787 113.567 103.087 117.217 103.087C119.442 103.087 121.642 103.537 123.192 104.387L121.917 107.637C120.642 106.937 118.617 106.512 117.017 106.512C115.542 106.512 114.817 106.862 114.817 107.437C114.817 108.062 115.367 108.437 117.142 108.787L118.242 108.987C122.092 109.712 123.592 111.087 123.592 113.637C123.592 116.087 121.467 117.962 117.167 117.962C114.892 117.962 112.467 117.412 110.867 116.512L112.192 113.112C113.467 113.937 115.392 114.537 117.267 114.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.333 106.837V103.587H127.983V98.4374H131.483V103.587H136.833V106.837H131.483V111.937C131.483 113.837 132.133 114.412 133.983 114.412H136.933V117.662H133.608C129.708 117.662 127.983 116.562 127.983 113.187V106.837H125.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.09 117.662V103.587H143.59V117.662H140.09ZM141.84 101.387C140.74 101.387 139.79 100.737 139.79 99.5124C139.79 98.4124 140.665 97.6624 141.84 97.6624C143.015 97.6624 143.865 98.4124 143.865 99.5124C143.865 100.637 143.04 101.387 141.84 101.387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.61 117.662V103.812C149.785 103.412 152.41 103.087 153.935 103.087C157.535 103.087 160.435 104.237 160.435 108.862V117.662H156.935V109.862C156.935 107.287 155.86 106.512 153.785 106.512C153.035 106.512 152.11 106.612 151.11 106.787V117.662H147.61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.387 113.912V106.812C172.612 106.637 171.887 106.512 171.212 106.512C168.462 106.512 166.687 107.712 166.687 110.337C166.687 112.937 168.462 114.187 171.212 114.187C171.837 114.187 172.537 114.112 173.387 113.912ZM163.012 110.337C163.012 106.212 166.037 103.087 171.237 103.087C173.262 103.087 175.162 103.337 176.887 103.837V116.587C176.887 121.562 175.137 123.287 169.562 123.287C168.462 123.287 166.637 123.012 165.512 122.662L164.762 119.012C166.137 119.612 168.337 120.062 169.712 120.062C171.862 120.062 173.387 119.362 173.387 117.712V117.412C172.437 117.562 171.587 117.612 170.962 117.612C166.162 117.612 163.012 114.462 163.012 110.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M197.849 -14.9819C193.941 23.4956 209.44 104.179 302.376 120.366M302.376 120.366C302.772 120.435 303.169 120.502 303.569 120.569C397.565 136.27 341.938 126.975 302.376 120.366Z",
    stroke: "white",
    strokeWidth: 1.57009
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M149.627 -1.96711C165.56 33.274 219.464 95.2776 307.969 62.6286M307.969 62.6286C308.346 62.4894 308.724 62.3485 309.103 62.2058C398.281 28.6048 345.504 48.4873 307.969 62.6286Z",
    stroke: "white",
    strokeWidth: 1.57009
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_5438_171301",
    x: -284,
    y: -234,
    width: 569,
    height: 569,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.39155
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.316718 0 0 0 0 0.0126224 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5438_171301"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.3915
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.26443
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5438_171301",
    result: "effect2_dropShadow_5438_171301"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 51
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5438_171301",
    result: "effect3_dropShadow_5438_171301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5438_171301",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddd_5438_171301",
    x: -208,
    y: -157,
    width: 416,
    height: 416,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.39155
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.316718 0 0 0 0 0.0126224 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5438_171301"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.3915
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.26443
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5438_171301",
    result: "effect2_dropShadow_5438_171301"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 51
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5438_171301",
    result: "effect3_dropShadow_5438_171301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5438_171301",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ddd_5438_171301",
    x: -148,
    y: -97,
    width: 296,
    height: 296,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.39155
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.316718 0 0 0 0 0.0126224 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5438_171301"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.3915
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.26443
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5438_171301",
    result: "effect2_dropShadow_5438_171301"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 51
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5438_171301",
    result: "effect3_dropShadow_5438_171301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5438_171301",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5438_171301",
    x1: 0,
    y1: 0,
    x2: 246,
    y2: 185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#FFD960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784375,
    stopColor: "#FFC409"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5438_171301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 185,
    rx: 4,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForecastingCard);
export default __webpack_public_path__ + "static/media/forecastingCard.20cb95cbc24629c1008853962a12bb40.svg";
export { ForwardRef as ReactComponent };